import {WidgetEventStruct} from '../../widget-event.struct';
import {ModalWidgetEnum, PinWidgetEnum, UserWidgetEnum} from '../../../enums';

export class PinWidgetEventStruct extends WidgetEventStruct {
  public event_pin_widget_type: PinWidgetEnum;
} // end Package
